import config from "../config"
import ProductModel from "./ProductModelMags"
import CategoryModel from "./CategoryModelMags"
import SessionModel from "./SessionModelMags"
import Api from "../sdk/Api.js"

// inject own Model
config.ProductModel = ProductModel
config.CategoryModel = CategoryModel
config.SessionModel = SessionModel

const shop = new Api(config)

window.shop = shop // DEBUG
export default shop



// WEBPACK FOOTER //
// ./src/shop/shop.js